import { hypercore, hyperevm } from '@polaris/core/evm'
import { makeOriginUrl } from '@polaris/core/utils'
import type { HttpTransport } from 'viem'
import { cookieStorage, createConfig, createStorage, http } from 'wagmi'
import {
  abstract,
  arbitrum,
  avalanche,
  base,
  bsc,
  ink,
  linea,
  mainnet,
  optimism,
  polygon,
  unichain,
  worldchain,
  zksync,
} from 'wagmi/chains'
import { injected } from 'wagmi/connectors'

const chains = [
  abstract,
  arbitrum,
  avalanche,
  base,
  bsc,
  hyperevm,
  hypercore,
  linea,
  mainnet,
  optimism,
  polygon,
  ink,
  zksync,
  worldchain,
  unichain,
] as const

const proxyTransports: Record<number, HttpTransport> = Object.fromEntries(
  chains.map((chain) => [
    chain.id,
    http(makeOriginUrl(`/api/chains/proxy?chainId=evm:${chain.id}`).toString()),
  ]),
)

export const wagmiConfig = createConfig({
  chains,
  connectors: [injected()],
  ssr: true,
  storage: createStorage({
    key: 'wagmi',
    storage: cookieStorage,
  }),
  transports: proxyTransports,
})
